export default "__VITE_ASSET__BeJ8gDpp__"